module.exports = __webpack_public_path__ + "media/images/icons/dropdown-62fe11201fff16ca70372e2117cec4f3.svg";